<div
  class="ai-questionnaire-clarify flex min-h-0 flex-1 flex-col gap-3"
  [class.ai-questionnaire-clarify--voice]="showVoiceRecorder()"
>
  <div class="ai-questionnaire-clarify__messages shrink-0 flex flex-col gap-2 overflow-y-auto overscroll-y-contain">
    @for (message of messages(); track $index) {
      <div
        class="w-full rounded-xl border border-[#ece4f3] px-3 py-2.5 text-sm leading-relaxed"
        [class.bg-white]="message.role === 'assistant'"
        [class.text-[#3d2652]]="message.role === 'assistant'"
        [class.bg-[#f3ebf8]]="message.role === 'user'"
        [class.text-[#5a2f6b]]="message.role === 'user'"
        [class.border-transparent]="message.role === 'user'"
      >
        @if (message.subjects?.length) {
          <p class="ai-questionnaire-clarify__intro">{{ message.text }}</p>
          <ul class="ai-questionnaire-clarify__subjects" role="list">
            @for (subject of message.subjects; track $index) {
              <li class="ai-questionnaire-clarify__subject">
                <span class="ai-questionnaire-clarify__subject-index" aria-hidden="true">{{ $index + 1 }}</span>
                <span class="ai-questionnaire-clarify__subject-label">{{ subject }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="ai-questionnaire-clarify__text">{{ message.text }}</span>
        }
      </div>
    }
  </div>

  @if (loading()) {
    <div class="ai-questionnaire-clarify__waiting">
      <mobile-spinner [messageKey]="loadingMessageKey()" [centered]="false" />
    </div>
  } @else if (requiresMoreClarification()) {
    <div
      class="ai-questionnaire-clarify__composer flex min-h-0 flex-1 flex-col"
      [class.gap-2]="!showVoiceRecorder()"
    >
      @if (showVoiceRecorder()) {
        <mobile-voice-purchase-request-recorder
          class="min-h-0 flex-1 self-stretch"
          [contextLabel]="contextLabel()"
          (recordError)="recordError.emit($event)"
          (sent)="onVoiceSent($event)"
        />
      } @else {
        <textarea
          rows="3"
          class="ai-questionnaire-clarify__answer min-h-0 w-full flex-1 resize-none rounded-xl border border-[#ece4f3] bg-white px-3 py-2 text-sm text-[#3d2652] outline-none focus:border-[#5a2f6b]"
          [placeholder]="'mobile.aiQuestionnaire.clarify.answerPlaceholder' | translate"
          [disabled]="loading()"
          [ngModel]="answerText()"
          (ngModelChange)="answerText.set($event)"
        ></textarea>
        <div class="flex shrink-0 gap-2">
          <button
            type="button"
            class="inline-flex min-h-[3rem] flex-1 items-center justify-center gap-1 rounded-xl border border-[#ece4f3] bg-white px-3 text-sm font-medium text-[#5a2f6b] disabled:opacity-60"
            [disabled]="loading()"
            (click)="toggleVoiceRecorder()"
          >
            <span class="material-icons text-[20px]" aria-hidden="true">mic</span>
            {{ "mobile.aiQuestionnaire.clarify.voiceAnswer" | translate }}
          </button>
          <button
            type="button"
            class="inline-flex min-h-[3rem] flex-1 items-center justify-center rounded-xl bg-[#5a2f6b] px-3 text-sm font-semibold text-white disabled:opacity-60"
            [disabled]="loading() || !answerText().trim()"
            (click)="submitTextAnswer()"
          >
            {{ "mobile.aiQuestionnaire.clarify.send" | translate }}
          </button>
        </div>
      }
    </div>
  }

  @if (!requiresMoreClarification()) {
    <button
      type="button"
      class="mt-auto shrink-0 w-full rounded-xl bg-[#5a2f6b] py-3 text-sm font-semibold text-white shadow-sm disabled:opacity-60"
      [disabled]="loading()"
      (click)="requestGenerate()"
    >
      {{ loading() ? ("mobile.aiQuestionnaire.clarify.generating" | translate) : ("mobile.aiQuestionnaire.clarify.generateDraft" | translate) }}
    </button>
  }
</div>
